import { useEffect, useState } from "react";

// Lightweight, self-contained ArcaOS access probe. Returns whether the current
// user can enter ArcaOS/Mission Control (member of at least one org). Used to
// gate the Mission Control entry point in headers outside the OS provider.
export function useArcaOSAccess() {
  const [state, setState] = useState({ hasAccess: false, loading: true });

  useEffect(() => {
    let alive = true;
    const token = localStorage.getItem("arca_token");
    if (!token) { setState({ hasAccess: false, loading: false }); return; }
    const headers = { Authorization: `Bearer ${token}` };
    const org = localStorage.getItem("arca_os_org");
    if (org) headers["X-Org-Id"] = org;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/os/attention/pulse`, { headers })
      .then((r) => { if (alive) setState({ hasAccess: r.ok, loading: false }); })
      .catch(() => { if (alive) setState({ hasAccess: false, loading: false }); });
    return () => { alive = false; };
  }, []);

  return state;
}
